import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import API from "../../api/backend/inventory";
import Loading from "../../component/Desktop/loading/loading";
import { isEmpty, MSG_CATCH, showMessage } from "../../constants/utils";
import { isString, isObject } from "lodash";
import { KEY } from "../../constants/common.const";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const App = ({ onAttachmentsChange, attachmentsData }) => {
  let [showLoading, setShowLoading] = useState(false);

  let openLoadingSpinner = () => {
    setShowLoading(true);
  };
  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [inventoryItemAttachments, setInventoryItemAttachments] = useState([]);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    setFileList(
      attachmentsData.map((image) => ({
        name: image.imageName,
        url: image.imageUrl,
        uid: image.id,
        status: "done",
      }))
    );
    setInventoryItemAttachments(attachmentsData);
  }, [attachmentsData]);

  useEffect(() => {
    onAttachmentsChange(getAttachments);
  }, [inventoryItemAttachments, onAttachmentsChange]);

  const getAttachments = () => {
    return inventoryItemAttachments;
  };

  const isAllowedFileType = (file) => {
    return ["image/png", "image/jpeg", "image/jpg", "image/jfif"].includes(
      file.type
    );
  };

  const beforeUpload = (file) => {
    const isValid = isAllowedFileType(file);
    if (!isValid) {
      //   showMessage(KEY.ERROR, "対応ファイル形式は.PNG .JPG .JPEG .JFIF");
    }
    return isValid;
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const removeLastFile = () => {
    setFileList((prevFileList) => {
      return prevFileList.slice(0, -1);
    });
  };
  const handleChange = async ({ fileList: newFileList }) => {
    const validFiles = newFileList.filter((file) => {
      if (file.originFileObj) {
        return isAllowedFileType(file.originFileObj);
      }
      return true;
    });
    setFileList(validFiles);
    // setFileList(newFileList);
    openLoadingSpinner();
    try {
      let fileListAfter = [];
      let fileListBefore = [];

      for (let i = 0; i < newFileList.length; i++) {
        if (
          fileListAfter.every((f) => f.name !== newFileList[i].name) &&
          fileListBefore.every((f) => f.name !== newFileList[i].name)
        ) {
          if (newFileList[i].originFileObj) {
            fileListAfter.push(newFileList[i]);
          } else fileListBefore.push(newFileList[i]);
        } else {
          showMessage(KEY.ERROR, "画像アップロードの重複。");
          removeLastFile();
        }
      }
      const uploadedFiles = await Promise.all(
        fileListAfter.map((file) => uploadSingleFile(file.originFileObj))
      );
      const beforFiles = fileListBefore.map((file) => ({
        imageUrl: file.url,
        imageName: file.name,
      }));
      setInventoryItemAttachments([...beforFiles, ...uploadedFiles]);
    } catch (error) {
    } finally {
      closeLoadingSpinner();
    }
  };
  const uploadButton = (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <button
          style={{
            border: "2px dashed #d9d9d9",
            cursor: "pointer",
            height: "80px",
            width: "125px",
          }}
          type="button"
        >
          <PlusOutlined />
          <div
            style={{
              marginTop: 8,
            }}
          >
            ファイルを選択
          </div>
        </button>
        <div
          style={{
            margin: "0px 0px 0px 16px",
          }}
        >
          <p style={{ color: "gray", fontSize: "12px" }}>
            ※ファイルサイズの上限は100MB以内です。
          </p>
          <p style={{ color: "gray", fontSize: "12px" }}>
            ※対応ファイル形式は.PNG .JPG .JPEG .JFIF
          </p>
        </div>
      </div>
    </>
  );
  const uploadSingleFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await API.uploadFile(formData);
      if (res.data && res.data.url) {
        return {
          imageUrl: res.data.url,
          imageName: file.name,
        };
      }
    } catch (err) {
      let msg = MSG_CATCH();
      if (
        !isEmpty(err.response) &&
        isString(err.response.data) &&
        !isEmpty(err.response.data)
      ) {
        msg = err.response.data;
      }
      if (
        !isEmpty(err.response) &&
        isObject(err.response.data) &&
        isString(err.response.data.msg)
      ) {
        msg = err.response.data.msg;
      }
      showMessage(KEY.ERROR, msg);
    }
  };
  return (
    <>
      <Upload
        listType="picture"
        beforeUpload={beforeUpload}
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        multiple
        accept=".png,.jpg,.jpeg,.jfif"
        className="mutil-upload-img"
      >
        {/* {fileList.length >= 10 ? null : uploadButton} */}
        {uploadButton}
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
      <Loading show={showLoading}></Loading>
    </>
  );
};
export default App;
